// App.jsx

import React, { lazy, Suspense } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./slider.scss";
import ChoiseCard from "../../molecules/cards/ChoiseCard";
// Use React.lazy to dynamically import the Slider component
const Slider = lazy(() => import("react-slick"));

export default function SlickSlider({ data, pakage }) {
  const slickSettings = {
    dots: true,
    infinite: true,
    speed: 1000,
    autoplay: true,
    slidesToShow: data?.length < 4 ? data?.length : 4,
    responsive: [
      {
        breakpoint: 786,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
    ],
  };

  return (
    <div className="App">
      <div>
        <Suspense fallback={<div>Loading...</div>}>
          <Slider {...slickSettings}>
            {data &&
              data.map((card, index) => (
                <ChoiseCard img={card?.images[0]?.image} title={card.title} />
              ))}
          </Slider>
        </Suspense>
      </div>
    </div>
  );
}

SlickSlider.defaultProps = {
  isFeaturedBadge: false,
};
